import { jsx as _jsx } from "react/jsx-runtime";
import { MASItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = ({ isPreviewLoading, isSubmitLoading, item, onCancel, onPreview, onSubmit }) => (_jsx(MASItem, { isAdd: true, isPreviewLoading: isPreviewLoading, isSubmitLoading: isSubmitLoading, item: item, onCancel: onCancel, onPreview: onPreview, onSubmit: onSubmit }));
export default Add;
